import { css } from "@linaria/core";
import { colors, spacings } from "@ui/Theme";

export const formSection = css`
  display: grid;
  grid-column: span 2;
  grid-template-columns: subgrid;
  transition: opacity var(--section-column-transition-duration)
    var(--section-column-transition-ease);
`;

export const formSectionHidden = css`
  opacity: 0;
  pointer-events: none;
`;

export const formSectionDatasetRangeSelector = css`
  margin-bottom: 32px;

  /* DateRangePicker */
  > div {
    grid-column: span 2;
  }
`;

export const formSectionResourceSelector = css`
  margin-bottom: 8px;
`;

export const formSectionDataTitleSetting = css`
  margin-bottom: 24px;
`;

export const formSectionDisplaySetting = css`
  margin-top: 32px;
  margin-bottom: 32px;
`;

export const formSectionTitle = css`
  color: ${colors.carbon700};
  padding: 8px 0px;
  display: flex;
  align-items: flex-end;
  gap: ${spacings.xxs};

  span:has(svg) {
    svg {
      transform: translateY(2px);
    }
  }
`;

export const formSectionItemFull = css`
  grid-column: span 2;
`;

export const FormPanel = css`
  align-items: center;
  column-gap: 4px;
  display: grid;
  grid-template-columns: 1fr max-content;
  // @note hardcoded for animation
  grid-template-rows: 110px 44px;
  transition: grid-template-rows var(--section-column-transition-duration)
    var(--section-column-transition-ease);
`;

export const formPanelWithEncodingFocused = css`
  grid-template-rows: 0px 0px;
`;

export const formSideBySideInputContainer = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;
